import { apiClient } from "./ApiClient";

export const retrieveAllAdminCostRatesApi = () =>
  apiClient.get("/api/admin-cost-rates");

export const retrieveAdminCostRateByYearApi = (year) =>
  apiClient.get(`/api/admin-cost-rates/${year}`);

export const createAdminCostRateApi = (rate) =>
  apiClient.post("/api/admin-cost-rates", rate);

export const updateAdminCostRateApi = (id, rate) =>
  apiClient.put(`/api/admin-cost-rates/${id}`, rate);

export const deleteAdminCostRateApi = (id) =>
  apiClient.delete(`/api/admin-cost-rates/${id}`);
